export default "__VITE_ASSET__BlQH53E1__"